import { observable, action, makeObservable, set } from 'mobx';

import { CashlessWriteOffType } from '../../shared/support/modelTypes';

export interface CashlessWriteOffFormStoreType {
	model: CashlessWriteOffType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude: Array<any>;
	selectedItems: Array<any>;
	requiredToFill: Array<{ predefinedName: string; property: string; relation: string }>;
	isFirstLoad: boolean;
	name: string;
	isSequenceNumberChangedManually: boolean;
	setValue(model: any, key: string, value: any): void;
}

class CashlessWriteOffFormStore implements CashlessWriteOffFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			filterInclude: observable,
			selectedItems: observable,
			requiredToFill: observable,
			isFirstLoad: observable,
			name: observable,
			isSequenceNumberChangedManually: observable,
			setValue: action
		});
	}

	model = {
		organizationId: null,
		organizationBankAccountId: null,
		amount: 0,
		partnerId: null,
		contractId: null,
		partnerBankAccountId: null,
		receiverBankAccountId: null,
		cashBoxReceiverId: null,
		incomeDocDate: new Date(),
		incomeDocNumber: '',
		paymentPurpose: null,
		note: null,
		accountablePersonId: null,
		postedByBank: false,
		postedAtBank: new Date(),
		bankPaymentId: null,
		posted: false,
		periodAt: null,
		responsibleId: null,
		deleted: false,
		authorId: null,
		ownerId: null,
		ownerType: null,
		documentBaseId: null,
		documentBaseType: null
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	isSequenceNumberChangedManually = false;
	pluralName = 'cashlessWriteOffs';
	filterInclude = ['partner', 'organization', 'contract', 'organizationBankAccount', 'partnerBankAccount', 'receiverBankAccount', 'cashBoxReceiver', 'accountablePerson'];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	requiredToFill = [
		{
			predefinedName: 'DefaultOrganization',
			property: 'organizationId',
			relation: 'organization'
		}
	];
	isFirstLoad = true;
	name = 'OrmCashlessWriteOff';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const cashlessWriteOffFormStore = new CashlessWriteOffFormStore();

export default CashlessWriteOffFormStore;
